<template lang="pug">
.v-feedback-form.feedback-form(v-if="data")
	.container
		.feedback-form__wrap
			.feedback-form__left
				h1.feedback-form__title(v-if="data.title" ) {{ data.title }}
			.feedback-form__right
				v-form.feedback-form__form(:data-source="computedData" :bxajaxid="data.bxajaxid")

</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {

	mixins: [
		sourceMixin
	],

	props: {
		slotProps: {
			type: Object,
			default: {}
		}
	},

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	},

	computed: {
		computedData() {
			if(this.slotProps.vacanciesId) {
				this.data.form.fields.push(
					{
						"groupId": "1",
						"id": "FIELD_VACANCIES_ID",
						"name": "FIELD_VACANCIES_ID",
						"type": "hidden",
						"value": this.slotProps.vacanciesId,
					}
				)
			}
			return this.data.form
		}
	}

}

</script>